import { COMMON } from '../constants/index';

export const commonActions = {
  reset: (): any => ({
    type: COMMON.reset,
  }),
};
